export default __webpack_public_path__ + "static/media/ret3.4b09da5d.jpeg";